import React from "react";
import { Link } from "react-router-dom";
import { HeartHandshake } from "lucide-react";

export function Logo({ to = "/", light = false }) {
  return (
    <Link to={to} data-testid="logo-link" className="flex items-center gap-2 group">
      <span className="inline-flex items-center justify-center h-9 w-9 rounded-xl bg-[#087A73] text-white shadow-sm group-hover:bg-[#06615B] transition-colors">
        <HeartHandshake className="h-5 w-5" />
      </span>
      <span className={`text-xl font-extrabold tracking-tight ${light ? "text-white" : "text-[#102A2A]"}`}>
        Etruria<span className="text-[#087A73]">Care</span>
      </span>
    </Link>
  );
}
